import React from "react";
import "./PlayerBrain.modules.css";
import { useRef, useEffect } from "react";

const PlayerBrain = ({ currentQuestion, userInput, handleInputChange }) => {
  const inputRef = useRef(null);

  // 全体クリックで非表示の入力欄にフォーカス
  useEffect(() => {
    const handleFocus = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    document.addEventListener("click", handleFocus);
    return () => document.removeEventListener("click", handleFocus);
  }, []);

  // 問題が設定されていない場合はreturn
  if (!currentQuestion) return;
  // 未入力の文字
  const currentWord = currentQuestion?.ANSWER_ROM;
  let leftWord = currentWord;
  // ゲーム開始時はcurrentWord, userInputがundefindでエラーになるためif内で未入力文字をセット
  if (currentWord && userInput) {
    leftWord = currentWord.slice(userInput.length);
  }

  // 未入力の文字（選択肢版）
  const currentOption = [
    currentQuestion?.OPTION_1_ROM,
    currentQuestion?.OPTION_2_ROM,
    currentQuestion?.OPTION_3_ROM,
  ];
  let leftOptionWord = [...currentOption];
  if (currentQuestion?.TYPE == "quiz") {
    if (currentOption && userInput) {
      leftOptionWord = currentOption.map((opt) => {
        return opt.startsWith(userInput) ? opt.slice(userInput.length) : opt;
      });
    }
  }

  // ３択用の選択肢
  const optionDisplay = (
    optNo,
    option_jp,
    option_rom,
    left_option_word,
    user_Input
  ) => {
    return (
      <div className={["option-1", "option-2", "option-3"][optNo - 1]}>
        <p>
          <span className="opt-no">{["①", "②", "③"][optNo - 1]}</span>
          <span className="target-word">{option_jp}</span>
        </p>
        <p className="input-left-word">
          {option_rom?.startsWith(user_Input) ? (
            <span className="input-word">{user_Input}</span>
          ) : (
            <></>
          )}
          <span className="left-word">{left_option_word}</span>
        </p>
      </div>
    );
  };

  return (
    <>
      <div className="player-brain">
        <div className="text-display-area">
          {/* 通常のタイピングモード */}
          {currentQuestion?.TYPE == "normal" ? (
            <>
              <div className="option">
                <p className="target-word">{currentQuestion?.ANSWER_JP}</p>
                <p className="input-left-word">
                  <span className="input-word">{userInput}</span>
                  <span className="left-word">{leftWord}</span>
                </p>
              </div>
            </>
          ) : (
            <>
              {/* ３択モード */}
              {optionDisplay(
                1,
                currentQuestion?.OPTION_1_JP,
                currentOption[0],
                leftOptionWord[0],
                userInput
              )}
              {optionDisplay(
                2,
                currentQuestion?.OPTION_2_JP,
                currentOption[1],
                leftOptionWord[1],
                userInput
              )}
              {optionDisplay(
                3,
                currentQuestion?.OPTION_3_JP,
                currentOption[2],
                leftOptionWord[2],
                userInput
              )}
            </>
          )}
          <div>
            <input
              type="text"
              ref={inputRef}
              value={userInput}
              onChange={handleInputChange} // 入力時のイベントを設定
              autoFocus // フォーカスを自動で設定
              tabIndex={-1} // タブキーでフォーカスされないようにする
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PlayerBrain;
